import styled from 'styled-components';

export const TreeContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100vh;
  min-height: 0;
  padding: 10px;

  /* Estilo moderno de scroll */
  .tree-scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
  }

  &::-webkit-scrollbar,
  .tree-scroll::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb,
  .tree-scroll::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.15);
    border-radius: 4px;
  }
  &::-webkit-scrollbar-track,
  .tree-scroll::-webkit-scrollbar-track {
    background: transparent;
  }

  scrollbar-width: thin; /* Firefox */
  scrollbar-color: rgba(0, 0, 0, 0.15) transparent;
`;
